import React from 'react';

import { ReservationOption } from '@/models';

export enum LOGIN_STEP {
  LASTNAME = 'lastName',
  FIRSTNAME = 'firstName',
  ARRIVALDATE = 'arrivalDate',
  SELECT_RESERVATION = 'selectReservation',
  RESERVATIONID = 'reservationId',
}

export type LoginState = {
  reservationId: string;
  lastName: string;
  firstName: string;
  arrivalDate: string;
  reservationNotFound: boolean;
  guestNotFound: boolean;
  loading: boolean;
  errorText: string;
  submittedFields: string[];
  currentStep: LOGIN_STEP;
  matchingReservations: ReservationOption[];
};

export type UseLoginReturn = {
  state: LoginState;
  setState: React.Dispatch<React.SetStateAction<LoginState>>;
  setStateField: <K extends keyof LoginState>(
    field: K,
    value: LoginState[K],
  ) => void;
  isSubmitDisabled: boolean;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => Promise<void>;
  canGoBack: boolean;
  onBack: () => void;
  currentStep: LOGIN_STEP;
  onSelectReservation?: (
    reservation: ReservationOption,
    flowType?: 'check-in' | 'check-out',
  ) => Promise<void>;
};
